import { type ValueOf } from '@dni-types/utilities/value-of'
import { type Variation } from '@hooks-api/types/dataModel/products'

export const PRODUCT_CARD_BADGE = {
  NEW: 'new',
  SALE: 'sale',
} as const

export type ProductCardBadgeType = ValueOf<typeof PRODUCT_CARD_BADGE>

export interface ProductCardEntry {
  key: string
  productId: number
  title: string
  imageUrl: string
  price: number
  subtitleChips?: string[]
  badge?: ProductCardBadgeType
  variations: Variation[]
}
